import { isElement } from '../detectInlineType';

import { type DOMNode, domToReact, type Element } from 'html-react-parser';

export interface InlineYouTubeProps {
  element: Element;
}

export function InlineYouTube({ element }: InlineYouTubeProps) {
  const children = element.children as DOMNode[];
  const iframe = children.find((c): c is Element => isElement(c) && c.name === 'iframe');
  const figcaption = children.find((c): c is Element => isElement(c) && c.name === 'figcaption');

  return (
    <figure className={element.attribs?.class ?? undefined}>
      <iframe
        src={iframe?.attribs?.src}
        height={iframe?.attribs?.height}
        width="100%"
        title={iframe?.attribs?.title ?? 'YouTube video player'}
        allowFullScreen
        loading="lazy"
      />
      {figcaption && <figcaption>{domToReact(figcaption.children as DOMNode[])}</figcaption>}
    </figure>
  );
}
